import { Box, Text, getPaletteColor } from 'pcln-design-system'
import Popover from 'pcln-popover'
import styled from 'styled-components'

/**
 * Grid components
 */
export const FlexDateCell = styled(Box)`
  display: block;
  line-height: 32px;
  text-align: center;
  width: 90px;
  border-radius: 6px;
  ${({ isTopLabel }) =>
    isTopLabel &&
    `
    margin-bottom: 15px;
    `}

  ${(props) =>
    !props.isSelected && props.position > 15
      ? `&:hover {
      background: ${getPaletteColor('primary.light')(props)};
      box-shadow: 0 0 0 1px ${getPaletteColor('primary.base')(props)};
      cursor: pointer;
    }`
      : ''}

  ${({ isReturnLabel }) =>
    isReturnLabel &&
    `
  position: sticky;
  left: 104px;
  `}
`

export const Label = styled(Box)`
  display: block;
  line-height: 2.1;
  text-align: center;
  width: 100px;
  border-radius: 0px;
  position: sticky;
  left: 0;

  @media only screen and (max-width: 1024px) {
    box-shadow: 2px 0px 2px -0.3px rgb(240, 240, 240);
  }
`

export const Background = styled(Box)`
  border-radius: 6px;
  color: white;
`

export const GridLayout = styled(Box)`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: 36px 36px 36px 36px 36px 36px 36px 36px 40px;
  overflow: auto;
  ${(props) => props.theme.mediaQueries[3]} {
    overflow: hidden;
  }
`

export const PriceLegendWrapper = styled(Box)`
  line-height: 1.8;
  text-align: left;
  width: 340px;
  border-radius: 6px;
  position: sticky;
  left: 0;
  transform: translateX(15px);
  @media only screen and (min-width: 1024px) {
    transform: translateX(108px);
  }
`
export const PriceBox = styled(Box)`
  display: inline;
  line-height: 1.8;
  text-align: center;
  width: 100%;
  border-radius: 10px;
  color: black;
  font-size: 12px;
`

export const AvgPrice = styled(Text)`
  display: inline;
  color: black;
  font-size: 12px;
`

export const StyledText = styled(Text)`
  font-size: 12px;
  ${({ isCheapest }) => isCheapest && 'color: #569156 '};
  ${({ isCheapest }) => isCheapest && 'font-weight: bold; '};
`

/**
 * Popover Component
 */

export const StyledPopover = styled(Popover)`
  -webkit-transition: opacity 1s ease-in-out; /* define transitions */
  transition: opacity 0.25s ease-in-out;
  border-radius: ${(props) => props.theme.borderRadii.xl} !important;

  &:hover:after {
    opacity: 0;
    border-radius: ${(props) => props.theme.borderRadii.xl} !important;
  }
`
